import { render, staticRenderFns } from "./AppHelp.vue?vue&type=template&id=31dc7bdc&scoped=true"
import script from "./AppHelp.vue?vue&type=script&lang=js"
export * from "./AppHelp.vue?vue&type=script&lang=js"
import style0 from "./AppHelp.vue?vue&type=style&index=0&id=31dc7bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc7bdc",
  null
  
)

export default component.exports